import React, { useCallback, useMemo } from 'react';
import {Layout, Button, Dropdown, Space, Col} from 'antd';
import {ExportOutlined, DownOutlined, EditOutlined} from '@ant-design/icons';

import styles from './PageHeader.module.css';
import { useAuthDispatch, useAuthState } from '../../Context/AuthProvider/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../Context/AuthProvider/AuthProviderActions';
import type {ItemType} from 'antd/es/menu/interface';
import {UserInfo} from '../UserInfo';

const { Header } = Layout;

export const DiazarPageHeader: React.FunctionComponent = () => {
    const dispatch = useAuthDispatch();
    const userDetails = useAuthState();
    const navigate = useNavigate();

    /* Función para cerrar sesión */
    const handleLogout = useCallback(() => {
        logout(dispatch);
        navigate('/login');
    }, [navigate, dispatch]);


    const handleEditeUser = useCallback(() => {
        if (userDetails.user){
            navigate(`/edit-user/${ userDetails.user.id }`);
        }
    }, [userDetails.user, navigate]);

    /* Opciones del menú de usuario */
    const userMenu = useMemo(() => {
        const menu: ItemType[] = [];

        if (userDetails.company){
            menu.push({
                key: 'company-name',
                label: (
                    <Button className="nav-user-info" block type="text" disabled >
                        <div><strong>Empresa</strong>: {userDetails.company.name}</div>
                    </Button>
                ),
                disabled: true,
            });
        }
        if (userDetails.user){
            menu.push({
                key: 'user-name',
                label: (
                    <Button className="nav-user-info" block type="text" disabled >
                        <div><strong>Nombre</strong>: {`${userDetails.user.first_name} ${userDetails.user.last_name}`}</div>
                    </Button>
                ),
                disabled: true,
            });

            menu.push({
                key: 'user-key',
                label: (
                    <Button className="nav-user-info" block type="text" disabled >
                        <div><strong>Clave</strong>: {userDetails.user.clave}</div>
                    </Button>
                ),
                disabled: true,
            });

            menu.push({
                key: 'user-email',
                label: (
                    <Button className="nav-user-info" block type="text" disabled >
                        <div><strong>Email</strong>: { userDetails.user.email }</div>
                    </Button>
                ),
                disabled: true,
            });

            menu.push({
                key: 'user-rol',
                label: (
                    <Button className="nav-user-info" block type="text" disabled >
                        <div><strong>Rol</strong>: { userDetails.user.rol }</div>
                    </Button>
                ),
                disabled: true,
            });
        }

        menu.push( {type: 'divider',} );

        menu.push({
            key: 'user-edit',
            label: (
                <Button block type="link" onClick={handleEditeUser} icon={<EditOutlined />} >
                    <div style={ {width: '100%', textAlign:'left'} }>
                        Editar
                    </div>

                </Button>
            ),
            disabled: true,
        });

        menu.push({
            key: 'user-logout',
            label: (
                <Button block type="text" onClick={handleLogout} icon={<ExportOutlined />} >
                    <div style={ {width: '100%', textAlign:'left'} }>
                        Logout
                    </div>

                </Button>
            ),
            disabled: true,
        });

        return menu;
        }
        /*(
        <Menu>


            {userDetails.user?.rol && userDetails.user.rol !== '' && (
                <Menu.Item key="user-type" disabled>
                    <strong>Rol</strong>: { userDetails.user.rol }
                </Menu.Item>
            )}

        </Menu>
    )*/
    , [userDetails, handleLogout]);


    const userInfo = useMemo(() => {
        if (userDetails.user === undefined) {
            return null;
        }
        const user = userDetails.user;

        return (
            <UserInfo user={ user } />
        );
    }, [userDetails]);

    return (
        <Header className={styles.header}>
            <Space align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
                {/* Logo */}
                <Col>&nbsp;</Col>

                {/* Botones de navegación */}
                <Space>
                    {userDetails.token && (
                        <Dropdown menu={{items:userMenu}} trigger={['click']} >
                            <Button type="link" icon={ <DownOutlined className="user-nav-info-btn-ico" />  }  iconPosition="end" >{ userInfo }</Button>
                        </Dropdown>
                    )}
                </Space>
            </Space>
        </Header>
    );
};
